import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IClient } from "../../Typings/Client";

export interface AdminState {
  adminClient: IClient;
}

export const adminInitialState: AdminState = {
  adminClient: {} as IClient,
};

export const AdminSlice = createSlice({
  name: "adminState",
  initialState: adminInitialState,
  reducers: {
    updateAdminState: (_state, action: PayloadAction<AdminState>) => ({
      ...adminInitialState,
      ...action.payload,
      adminClient: action.payload.adminClient,
    }),
    resetAdminState: (state) => ({ ...state, adminClientId: {} as IClient }),
  },
});
export const { updateAdminState, resetAdminState } = AdminSlice.actions;
export const selectAdminState = (state: any) => state.adminState;
export default AdminSlice.reducer;
